var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e41d33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce1126"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d0d0d"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v3.809524h-16z",
    fill: "url(#c)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 7.619048h16v3.809524h-16z",
    fill: "url(#d)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 3.809524h16v3.809524h-16z",
    fill: "url(#a)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.0952381 4.94886779c0-.20845392.1767113-.37743922.38095238-.37743922h.18869164c.10618267 0 .22741699.0703125.28061639.17671131l.29259673.58519345s.4185376-.76190476.76190476-.76190476c.38095238 0 .76190476.76190476.76190476.76190476l.29259673-.58519345c.04879748-.09759496.1698928-.17671131.28061638-.17671131h.18869165c.21039421 0 .38095238.16438293.38095238.37743922v1.53083584c0 .20845393-.14013668.28401475-.31229074.16924541l-.8305664-.55371094h-.38095238v.38095238c0 .21039418-.17671131.38095238-.38095238.38095238-.21039421 0-.38095238-.17671131-.38095238-.38095238v-.38095238h-.38095238l-.83056641.55371094c-.17247341.11498227-.31229073.04381088-.31229073-.16924541z",
    fill: "#f4b32e",
    fillOpacity: 0.25,
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.52380952 6.14532682v-1.19294587h-.14551085l-.41097699.82195398zm-2.90210818-1.19294587h-.14497989c-.00026247-.00050884-.00053097-.00154387-.00053097-.00351316v1.19645903l.55648784-.37099189zm1.37829866.76190476v.76190477-.76190477h.52646324l-.10529265-.21058529c-.03827931-.07655862-.11107368-.20134901-.20212297-.32274804-.09187535-.12250052-.17618065-.19849996-.20705859-.22130414-.05560404.03568713-.13554522.11630611-.22054476.22603037-.09632069.1243384-.17590462.25178645-.21945816.3310712l-.10851253.1975359zm.66580556-.55131946c.06042758.09902389.0960992.17036708.0960992.17036708l.08518354-.17036708s.17643383-.14908635.11949501-.23898997l.08791818-.1758364c.04879748-.09759496.1698928-.17671131.28061638-.17671131h.18869165c.21039421 0 .38095238.16438293.38095238.37743922v1.53083584c0 .20845393-.14013668.28401475-.31229074.16924541l-.8305664-.55371094h-.38095238v.38095238c0 .21039418-.17671131.38095238-.38095238.38095238-.21039421 0-.38095238-.17671131-.38095238-.38095238v-.38095238h-.38095238l-.83056641.55371094c-.17247341.11498227-.31229073.04381088-.31229073-.16924541v-1.53083584c0-.20845392.1767113-.37743922.38095238-.37743922h.18869164c.10618267 0 .22741699.0703125.28061639.17671131l.09161122.18322244c-.05441343.08219739.11164244.22328487.11164244.22328487l.08934307.17868614s.04039114-.07352791.10637218-.17490039l.13566549-.19285968c.14890084-.19477051.34421924-.39414469.51986709-.39414469.19118438 0 .38236876.1918952.52540099.38307693z",
    fill: "#c6a846",
    mask: "url(#e)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEg);
export default __webpack_public_path__ + "static/media/EG.2558155f313ca30cafffb2b61c06de96.svg";
export { ForwardRef as ReactComponent };